import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OrderListItemModel } from '../../../core/models/order/order-list-item.model';
import { TextKeys } from '../../../core/i18n/text-keys';
import { Observable, Subscription } from 'rxjs';
import { BadgeQuery } from '../../../core/state-mangement/badge/badge.query';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../core/services/toast-service';
import { Location } from '@angular/common';
import { MaterialItemsService } from '../../../core/state-mangement/entities/material-items/material-items.service';
import { MaterialCatalogueItemsService } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.service';
import { MaterialCatalogueItemsQuery } from '../../../core/state-mangement/entities/material-catalogue-items/material-catalogue-items.query';
import { MaterialItemsQuery } from '../../../core/state-mangement/entities/material-items/material-items.query';
import { MaterialFormSettingsModel } from '../../../core/models/material/material-form-settings.model';
import { MaterialFormComponent } from '../materail-form/material-form.component';
import { OrderItemsQuery } from '../../../core/state-mangement/entities/order-items/order-items.query';
import { LocalStateKeys } from '../../../core/state-mangement/local-state-keys';
import { OrderItemsStoreService } from '../../../core/state-mangement/order-items-store-service';
import { StoreInfoParams } from '../../../core/models/store-info-params';
import { Router } from '@angular/router';
import { MaterialModel } from '../../../core/models/material/material-model';
import { PersonalApiModel } from '../../../core/models/personal/person-api.model';
import { OrderModel } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-material-edit',
  templateUrl: './material-edit.component.html',
  styleUrls: ['./material-edit.component.scss'],
})
export class MaterialEditComponent implements OnInit, OnDestroy {
  @ViewChild('formElement') formElement: MaterialFormComponent;

  orderStoreKey: LocalStateKeys;
  currentOrder: OrderListItemModel;
  defaultValues: MaterialModel;

  title: string;
  isLoading$: Observable<boolean>;
  displaySettings = {
    date: true,
    number: true,
    name: true,
    description: true,
    quantity: true,
    unit: true,
    price: true,
    total: true,
    note: true,
  } as MaterialFormSettingsModel;

  texts = TextKeys;

  private subscriptions = new Subscription();
  private orderItemsQuery: OrderItemsQuery;

  constructor(
    private materialItemsQuery: MaterialItemsQuery,
    private router: Router,
    private badgeQuery: BadgeQuery,
    private materialCatalogueItemsService: MaterialCatalogueItemsService,
    private translateService: TranslateService,
    private materialCatalogueItemsQuery: MaterialCatalogueItemsQuery,
    private materialItemsService: MaterialItemsService,
    private toastService: ToastService,
    private orderItemsStoreService: OrderItemsStoreService,
    private location: Location
  ) {}

  ngOnInit() {
    const value = this.router.getCurrentNavigation().extras
      .state as StoreInfoParams;
    if (!value) {
      this.location.back();
    }
    this.orderStoreKey = value.orderStoreKey;
    this.orderItemsQuery = this.orderItemsStoreService.getOrCreateStore(
      this.orderStoreKey
    ).query;

    this.defaultValues = this.materialItemsQuery.getActive();
    this.currentOrder = this.orderItemsQuery.getActive();
    if (!this.currentOrder) {
      this.location.back();
    }
    this.title = this.translateService
      .instant(this.texts.material.titleEdit)
      .replace(
        '#1',
        this.currentOrder?.orderNumber + ' - ' + this.currentOrder?.orderName
      );

    this.subscriptions.add(
      this.materialCatalogueItemsQuery.selectActive().subscribe((material) => {
        if (material?.materialCatalogueID) {
          setTimeout(() => this?.formElement?.setValues(material), 0);
        }
      })
    );
    this.isLoading$ = this.materialItemsQuery.selectLoading();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.materialCatalogueItemsService.clearCache();
  }

  onSave(event) {
    event.stopImmediatePropagation();
    this.formElement.markAllTouched();
    if (!this.formElement.allRequiredFiled()) {
      this.toastService.presentErrorToast({
        message: this.translateService.instant(
          this.texts.timeEntryForm.allFields
        ),
      });
      return;
    }

    const changedMaterial = {
      description: this.formElement.Name.value,
      description2: this.formElement.Description.value,
      quantity: this.formElement.Quantity.value,
      unit: this.formElement.Unit.value,
      price: this.formElement.Price.value,
      // eslint-disable-next-line id-blacklist
      number: this.formElement.MaterialNumber.getValue(),
      note: this.formElement.Note.value,
      date: new Date(this.formElement.Date.value),
      person: {
        id: this.materialItemsQuery.getActive()?.person.id,
      } as PersonalApiModel,
      order: {
        id: this.materialItemsQuery.getActive()?.order.id,
      } as OrderModel,
      id: this.materialItemsQuery.getActive()?.id,
    } as MaterialModel;

    this.materialItemsService.saveChangedMaterial(changedMaterial).subscribe(
      (data) => {
        this.formElement.clearForm();
        this.materialItemsService.clearCache();
        this.materialItemsService.getNextPage(this.orderStoreKey);
        this.toastService.presentInfoToast({ message: data.message });
        this.location.back();
      },
      (error) => {
        if (error.error?.message) {
          this.toastService.presentErrorToast({ message: error.error.message });
        }
      }
    );
  }

  onCancel(event) {
    event.stopImmediatePropagation();
    this.location.back();
  }
}
